module.exports = __webpack_public_path__ + "img/screen-without-photo.08f9f53b.svg";